export enum ContentClass {
  video = 'video',
  image = 'image',
  audio = 'audio',
}
